import React from "react";

export function BulbIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      width="22"
      height="28"
      viewBox="0 0 22 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        opacity="0.35"
        d="M17.0509 19.1717C19.6646 17.2879 21.3721 14.227 21.3721 10.7589C21.3721 5.03104 16.7281 0.387054 11.0002 0.387054C5.2724 0.387054 0.628418 5.03104 0.628418 10.7589C0.628418 14.227 2.33588 17.2879 4.94958 19.1717L5.78321 22.4272H16.2173L17.0509 19.1717Z"
        fill="currentColor"
      />
      <path
        d="M15.6377 24.6882L16.2173 22.4272H5.7832L6.36143 24.6882C6.80223 26.4087 8.35282 27.6131 10.129 27.6131H11.8702C13.6476 27.6131 15.1982 26.4087 15.6377 24.6882Z"
        fill="currentColor"
      />
    </svg>
  );
}
